export default class TabAttention {
  constructor() {
    this.baseTitle = document.title;
    this.writtenTitle = null;
    this.count = 0;
    this.icons = new Map();
    this.destroyed = false;
    this.observer = new MutationObserver(() => this.apply());
    this.observer.observe(document.head, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['href'] });
  }
  set(count) { this.count = Math.max(0, Number(count) || 0); this.apply(); }
  apply() {
    if (this.destroyed) return;
    if (document.title !== this.writtenTitle) this.baseTitle = document.title.replace(/^\(\d+\) Attention · /, '');
    const title = this.count ? `(${this.count}) Attention · ${this.baseTitle}` : this.baseTitle;
    this.writtenTitle = title;
    if (document.title !== title) document.title = title;
    let links = [...document.querySelectorAll('link[rel="icon"],link[rel="shortcut icon"]')];
    if (!links.length) {
      const fallback = document.createElement('link'); fallback.rel = 'icon'; fallback.href = '/favicon.ico';
      document.head.appendChild(fallback); links = [fallback];
    }
    for (const link of links) {
      const remembered = this.icons.get(link);
      if (!remembered || (link.href !== remembered.written && link.href !== remembered.base)) {
        const image = new Image();
        const value = { base: link.href, written: null, type: link.type, image };
        image.onload = () => { value.count = null; this.apply(); };
        this.icons.set(link, value); image.src = link.href;
      }
      const saved = this.icons.get(link);
      if (!this.count) {
        if (link.href !== saved.base) link.href = saved.base;
        link.type = saved.type;
        saved.written = saved.base;
        saved.count = 0;
        continue;
      }
      if (saved.count === this.count && link.href === saved.written) continue;
      const canvas = document.createElement('canvas'); canvas.width = 32; canvas.height = 32;
      const ctx = canvas.getContext('2d');
      if (!ctx) continue;
      if (saved.image.complete && saved.image.naturalWidth) {
        try { ctx.drawImage(saved.image, 0, 0, 32, 32); } catch { /* independent fallback badge */ }
      }
      ctx.fillStyle = '#b42318'; ctx.beginPath(); ctx.arc(21, 21, 11, 0, Math.PI * 2); ctx.fill();
      ctx.font = 'bold 14px sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillStyle = '#fff';
      ctx.fillText(this.count > 9 ? '9+' : String(this.count), 21, 22);
      try { saved.written = canvas.toDataURL('image/png'); link.href = saved.written; link.type = 'image/png'; saved.count = this.count; } catch { /* title/dashboard stay independent */ }
    }
  }
  destroy() {
    this.observer.disconnect(); this.set(0); this.destroyed = true;
    for (const saved of this.icons.values()) saved.image.onload = null;
    this.icons.clear();
  }
}
